import { DeleteDamagedAdjusterDocumentImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteDamagedAdjusterDocumentImages/deleteDamagedAdjusterDocumentImagesQuery.type';
import { deleteDamagedAdjusterDocumentImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteDamagedAdjusterDocumentImages/deleteDamagedAdjusterDocumentImagesQueryFunction';

export const deleteDamagedAdjusterDocumentImagesQueryOptions = () => {
  return {
    mutationKey: ['deleteDamagedAdjusterDocumentImages'],
    mutationFn: (params: DeleteDamagedAdjusterDocumentImagesQueryParamsType) =>
      deleteDamagedAdjusterDocumentImagesFunction(params),
  };
};
